import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const Angle: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2, 2, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3 9.988 5.558 3.53l1.384-1.444 7.5 7.186.758.727-.763.722-7.5 7.091-1.374-1.453 6.737-6.37Z"
        />
    </svg>
);

export default Angle;
